// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__IuABF","footer":"ModalCreateQualiphyProcedure_footer__2K5_S","additionData":"ModalCreateQualiphyProcedure_additionData__3maQQ"};